<template>
  <div>
    <v-dialog
      v-model="sendToStaffModal"
      persistent
      max-width="500px"
    >
      <v-card>
        <form @submit.prevent="submitForm()">
          <v-card-title class="pb-0">
            <v-flex
              xs11
              sm10
              md10
            >
              <span class="headline">
                Send to staff
              </span>
            </v-flex>
            <v-flex
              xs1
              sm2
              md2
            >
              <v-btn
                flat
                @click="closeDialog()"
                class="close"
              >
                &nbsp;X
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text v-if="sendToStaffModal">
            <v-layout wrap>
              <v-flex
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>Case ID: </b> {{ formData.order_case_id_fk }}
              </v-flex>

              <v-flex
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>Order ID: </b> {{ formData.theOrderID }}
              </v-flex>

              <v-flex
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>Customer: </b> {{ formData.full_name }}
              </v-flex>

              <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  autocomplete
                  :items="staffList"
                  v-model="formData.user_id_fk"
                  :error-messages="errors.collect('Staff')"
                  data-vv-name="Staff"
                  label="Staff*"
                  v-validate="'required'"
                  single-line
                />
              </v-flex>

              <v-flex
                xs12
                class="px-2 pb-4 mb-1"
              >
                <label class="d-block mb-1">Deadline</label>
                <input
                  type="datetime-local"
                  v-model="formData.deadline"
                  class="base-date-picker"
                >
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeDialog()"
              outline
              color="normal"
            >Cancel</v-btn>
            <v-btn
              type="submit"
              :loading="loading"
              style="height:auto; margin-right: 2%"
              outline
              color="success"
            >
              Send
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['sendToStaffModal', 'formData', 'staffList'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          Axios.post('api/order-case-user', this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          })
            .then(() => {
              swal({
                title: 'Sent',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
              this.$emit('resetTable')
              this.closeDialog()
            })
            .catch(error => {
              swal('Error', `${error.response.data.message}`, 'error')
            })

        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orderCase/sendToStaff.vue